import React, { useState } from 'react';
import styles from './index.module.scss';
import { Grid } from '@mui/material';
import Typography from '@mui/material/Typography';
import AppLogoMin from '../../assets/AppLogoMin.svg';
import InputField from '../../atoms/InputField';
import ArrowLeft from '../../assets/ArrowLeft.svg';
import {
  ButtonVariant,
  ButtonType,
  CustomButton,
} from '../../atoms/CustomButton';
import { scaleByRatio } from '../../utils/helper';

const ProfileDataDOB = ({
  dob,
  onDateChange,
  onNextClicked,
  onBackClicked,
  age,
  error,
  submitBtnText = 'Next',
  showBackButton = true,
}) => {
  const formatUsDobInput = (value) => {
    const digits = value.replace(/\D/g, '').slice(0, 8);
    if (digits.length <= 2) {
      return digits;
    }
    if (digits.length <= 4) {
      return `${digits.slice(0, 2)}/${digits.slice(2)}`;
    }
    return `${digits.slice(0, 2)}/${digits.slice(2, 4)}/${digits.slice(4)}`;
  };

  const handleDateChange = (evt) => {
    let newValue = formatUsDobInput(evt.target.value);
    console.log('handleDateChange :', newValue);
    onDateChange(newValue);
  };
  const handleOnNextClicked = (evt) => {
    onNextClicked();
  };
  return (
    <>
      <Grid
        container
        direction="row"
        justifyContent="center"
        alignItems="flex-end">
        <Grid item className={styles.logoContainer} marginTop={-8}>
          {/* <Typography textAlign='center' className={styles.logoContainer}> */}
          <img
            src={AppLogoMin}
            alt={'App icon'}
            className={styles.logo}
            style={{
              width: `90%`,
              marginBottom: '40px',
              marginTop: '-40px',
              height: `${scaleByRatio(110)}px`,
            }}
          />
          {/* </Typography> */}
        </Grid>
      </Grid>
      {showBackButton && (
        <Grid
          container
          direction="row"
          justifyContent="left"
          alignItems="flex-end">
          <Grid item className={styles.logoContainer}>
            <img
              src={ArrowLeft}
              alt={'Back icon'}
              className={styles.logoBack}
              onClick={onBackClicked}
              width={scaleByRatio(24)}
              height={scaleByRatio(24)}
            />
          </Grid>
          <Grid item>
            <Typography
              textAlign="left"
              className={styles.back}
              onClick={onBackClicked}
              style={{
                fontSize: `${scaleByRatio(12)}px`,
                paddingLeft: `${scaleByRatio(10)}px`,
                paddingBottom: `${scaleByRatio(2)}px`,
              }}>
              Back
            </Typography>
          </Grid>
        </Grid>
      )}
      <Grid
        container
        direction="row"
        justifyContent="left"
        alignItems="flex-end">
        <Grid item>
          <Typography
            textAlign="left"
            className={styles.description}
            style={{
              fontSize: `${scaleByRatio(22)}px`,
              lineHeight: `${scaleByRatio(28.64)}px`,
              letterSpacing: '0.06em', 
              marginLeft: '15px'
            }}>
            Your Date of Birth?
          </Typography>
        </Grid>
      </Grid>
      <Grid
        container
        direction="row"
        justifyContent="left"
        alignItems="flex-end">
        <InputField
          name="DOB"
          id={'DOB'}
          value={dob}
          placeholder={'MM/DD/YYYY'}
          handleChange={(evt) => handleDateChange(evt)}
          type={'text'}
          class_name={styles.name}
        />
      </Grid>

      {error && error?.length > 0 && (
        <Grid
          container
          direction="row"
          justifyContent="left"
          alignItems="flex-end">
          <Typography
            textAlign="left"
            className={styles.error}
            style={{
              fontSize: `${scaleByRatio(12)}px`,
              lineHeight: `${scaleByRatio(40)}px`,
            }}>
            {error}
          </Typography>
        </Grid>
      )}
      <Grid
        container
        direction="row"
        justifyContent="end"
        alignItems="flex-end">
        <Grid item>
          <CustomButton
            text={submitBtnText}
            variant={ButtonVariant.contained}
            type={ButtonType.primary}
            onClick={handleOnNextClicked}
            customStyle={`yes`}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default ProfileDataDOB;
